import React, { FC } from 'react';
import { Box, Card, CardContent, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import PageTitle from 'components/shared/page-title/page-title.component';
import LabAvailabilityActions from 'components/manage-labs/lab-availability/lab-availability-actions.component';

const LabAvailability: FC = () => {
    const { t: translate } = useTranslation(['common', 'organization']);
    const { labId } = useParams<{ labId: string }>();
    return (
        <Box>
            <PageTitle headingStyle="h1" title={translate('organization:AVAILABILITY')} />
            <Card sx={{ boxShadow: 3 }}>
                <CardContent sx={{ p: 3 }}>
                    <LabAvailabilityActions labId={labId || ''} />
                </CardContent>
            </Card>
        </Box>
    );
};

export default LabAvailability;
